import React from 'react'

const Frontend = ({isDarkMode}) => {
    const bodyClass = `skills__content ${isDarkMode ? 'dark-mode': ''}`
    return (
        <div className={bodyClass}>
            <h3 className="skills__title">Frontend Development</h3>

            <div className="skills__box">
                <div className="skills__group">

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">HTML5</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">CSS3</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">JavaScript(ES6)</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Tailwind</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>
                </div>
                <div className="skills__group">
                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">ReactJs</h3>
                            <span className="skills__level">Advance</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Angular</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Vue</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">NextJs</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default Frontend
